import React from 'react';

// ** components imports
import Badge from '../../../common/Badge';

// ** enums imports
import { BADGE_THEMES } from '../../../../enums/common';

const QuestionDetails = ({ question }) => {
  return (
    <div className="space-y-3 mt-3">
      {/* Question Description */}
      {question.description && (
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {question.description}
        </p>
      )}

      {/* Opt-out Status */}
      {question.hasOptOut && question.optedOut && (
        <div className="text-sm">
          <Badge
            theme={BADGE_THEMES.opted_out}
            text={question.optOutLabel || 'Opted out'}
            size="sm"
          />
        </div>
      )}

      {/* Validation Errors */}
      {!question.isValid &&
        question.validationErrors &&
        question.validationErrors.length > 0 && (
          <div className="text-xs text-orange-600 dark:text-orange-400">
            <span className="font-medium">Validation Issues: </span>
            <ul className="list-disc list-inside mt-1">
              {question.validationErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}

      {/* Help Text */}
      {question.helpText && (
        <div className="text-xs text-gray-500 dark:text-gray-400">
          <span className="font-medium">Help: </span>
          {question.helpText}
        </div>
      )}

      {/* Timestamps */}
      {(question.answeredAt || question.lastModifiedAt) && (
        <div className="text-xs text-gray-500 dark:text-gray-400 flex flex-wrap gap-2">
          {question.answeredAt && (
            <span>
              <span className="font-semibold">Answered:</span>{' '}
              {new Date(question.answeredAt).toLocaleString()}
            </span>
          )}
          {question.lastModifiedAt &&
            question.lastModifiedAt !== question.answeredAt && (
              <span>
                <span className="font-semibold">Modified:</span>{' '}
                {new Date(question.lastModifiedAt).toLocaleString()}
              </span>
            )}
        </div>
      )}

      {/* Enhanced File Upload Information */}
      {(question.type === 'FILE_UPLOAD' || question.type === 'FILE') && (
        <div className="mt-2 space-y-2">
          {question.acceptedFormats && question.acceptedFormats.length > 0 && (
            <div className="text-xs text-gray-500 dark:text-gray-400">
              <span className="font-medium">Accepted formats: </span>
              <div className="mt-1 flex flex-wrap gap-1">
                {question.acceptedFormats.map((format, index) => (
                  <span
                    key={index}
                    className="inline-block px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded text-xs"
                  >
                    {format}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs text-gray-500 dark:text-gray-400">
            {question.maxFiles && (
              <div>
                <span className="font-medium">Max files: </span>
                <span>{question.maxFiles}</span>
              </div>
            )}
            {question.maxFileSize && (
              <div>
                <span className="font-medium">Max size: </span>
                <span>{question.maxFileSize} bytes</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Array/Repeater Configuration */}
      {(question.type === 'REPEATER' || question.type === 'ARRAY') && (
        <div className="mt-2 space-y-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs text-gray-500 dark:text-gray-400">
            {question.minItems !== undefined && (
              <div>
                <span className="font-medium">Min items: </span>
                <span>{question.minItems}</span>
              </div>
            )}
            {question.maxItems !== undefined && (
              <div>
                <span className="font-medium">Max items: </span>
                <span>{question.maxItems}</span>
              </div>
            )}
          </div>

          {question.itemTemplate && (
            <div className="text-xs text-gray-500 dark:text-gray-400">
              <span className="font-medium">Item template: </span>
              <pre className="mt-1 p-2 bg-gray-100 dark:bg-gray-800 rounded text-xs overflow-x-auto">
                {JSON.stringify(question.itemTemplate, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QuestionDetails;
